<template>
    <span
        class="flex size-7 shrink-0 items-center justify-center rounded-full"
        :style="{ backgroundColor: `${colour}1A`, color: colour }"
        :title="type?.name ?? undefined"
    >
        <SvgIcon
            :name="icon"
            class="size-4"
        />
    </span>
</template>

<script setup lang="ts">
import {
    COMPANY_DIARY_FALLBACK_COLOUR,
    COMPANY_DIARY_FALLBACK_ICON,
    COMPANY_DIARY_ICONS,
} from './companyDiaryTypeOptions';

/**
 * An entry type as one glyph - the diary's whole visual vocabulary.
 *
 * Both fields fall back, because both are nullable on the type and an entry whose
 * badge rendered as nothing would be indistinguishable from a rendering failure.
 * An icon name the app does not ship falls back too: `SvgIcon` draws an empty
 * symbol for an unknown name rather than erroring, which is the same invisible
 * failure by a different route.
 */
const props = defineProps<{
    type?: { name?: string | null; colour?: string | null; icon?: string | null } | null;
}>();

const colour = computed(() => props.type?.colour || COMPANY_DIARY_FALLBACK_COLOUR);

const icon = computed(() => {
    const name = props.type?.icon;

    return name && COMPANY_DIARY_ICONS.some((option) => option.name === name) ? name : COMPANY_DIARY_FALLBACK_ICON;
});
</script>
